module.exports = __webpack_public_path__ + "static/media/equipment-calibration.96137de1.svg";